export const DATA_DENSITY = 'small';
export const DATA_DENSITY_LARGE = 'large';

export const FALLBACK_DISPLAY_VALUE = '-';
export const NA = 'N/A';

export const NAME = 'Name';

export const NOT_INCLUDED_IN_CALC_LABEL = 'Not included in total';
